export default "__VITE_ASSET__8jNRF$3n__"